export const isAbortError = (error: unknown): boolean => {
  if (!error) return false;
  if (typeof error === 'string') {
    return /aborterror|the user aborted a request/i.test(error);
  }
  if (typeof error === 'object') {
    const err = error as { name?: string; message?: string; code?: number | string };
    if (err.name === 'AbortError') return true;
    if (err.code === 20 || err.code === 'ABORT_ERR') return true;
    if (
      typeof err.message === 'string' &&
      (/the user aborted a request/i.test(err.message) ||
        (err.name === 'DOMException' && /abort/i.test(err.message)))
    ) {
      return true;
    }
  }
  return false;
};

export default isAbortError;
